import React from 'react';
import classNames from 'classnames';
import {
  Dialog, DialogClose, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import {
  addressFormatter, optionClassFormatter, statusNumberFormatter, statusNumberFormatterWithZone,
} from '../../../utils/formatters';
import {
  ActionsFormatter,
  battery1VoltageFormatter,
  battery2VoltageFormatter,
  lowerDoorFormatter,
  MoreFormatter,
  powerSupplyFormatter,
  StatusFormatter,
  StatusFormatterWithProblem,
  upperDoorFormatter,
  WorkingStateFormatter,
} from './ParkingFormatters';
import { Icons } from '../../../components/base/BootstrapComponents';

export default function ParkingMeterPopup(props) {
  const { handleClose = () => {}, item } = props;
  if (!item) {
    return null;
  }
  const {
    zbx_address,
  } = item;
  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-popup"
      size="xl"
    >
      <DialogTitle header="Информация о паркомате" title={<DialogClose onClick={handleClose} />} />
      <DialogContent>
        <div className="pmp-table">
          <div className={classNames('pmp-table-row', optionClassFormatter(item.status))}>
            <div className="pmp-table-cell">Номер паркомата</div>
            <div className="pmp-table-cell">{statusNumberFormatterWithZone(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Адрес  факт./юрид.</div>
            <div className="pmp-table-cell">{addressFormatter(zbx_address)}</div>
          </div>
          <div className="pmp-table-row pm-status">
            <div className="pmp-table-cell">Состояние</div>
            <div className="pmp-table-cell"><StatusFormatterWithProblem item={item} /></div>
          </div>
          <div className="pmp-table-row pm-last-ping">
            <div className="pmp-table-cell">Дата и время сбора данных</div>
            <div className="pmp-table-cell"><StatusFormatter item={item} /></div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Работа устройства</div>
            <div className="pmp-table-cell"><WorkingStateFormatter item={item} /></div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Нижняя дверь</div>
            <div className="pmp-table-cell">{lowerDoorFormatter(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Верхняя дверь</div>
            <div className="pmp-table-cell">{upperDoorFormatter(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Напряж-е на 1 АКБ</div>
            <div className="pmp-table-cell">{battery1VoltageFormatter(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Напряж-е на 2 АКБ</div>
            <div className="pmp-table-cell">{battery2VoltageFormatter(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Питание</div>
            <div className="pmp-table-cell">{powerSupplyFormatter(null, item)}</div>
          </div>
          <div className="pmp-table-row">
            <div className="pmp-table-cell">Действие</div>
            <div className="pmp-table-cell pm-popup-actions">
              <ActionsFormatter item={item} />
              <MoreFormatter item={item} />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
